// extracted by mini-css-extract-plugin
export default {"FeatureList":"FeaturedProjects_FeatureList__fyYrY"};